import { render, staticRenderFns } from "./ProjectStatusChip.vue?vue&type=template&id=1f144649"
import script from "./ProjectStatusChip.vue?vue&type=script&lang=ts"
export * from "./ProjectStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports